import Vue from 'vue';
import state from '../state';

let timezonesPromise = null;

export default {
  ensure() {
    if (!timezonesPromise) {
      timezonesPromise = Vue.http.get('/api/timezones');
      timezonesPromise.then(response => {
        state.timezones.set(response.data);
      });
    }
    return timezonesPromise;
  },
  async reloadAll() {
    const timezones = (await Vue.http.get('/api/timezones')).data;
    state.timezones.set(timezones);
  },
  unset() {
    state.timezones.set([]);
    timezonesPromise = null;
  }
}



// WEBPACK FOOTER //
// ./src/services/timezone.service.js